import React, { Component } from "react";

import {
  Wrapper,
  CardBody,
  Title,
  Copy,
  Bold,
  Row,
  Icon,
  Button,
  Spin
} from "app/NativeComponents/common";

import MessageHeaderImage from "./MessageHeaderImage";

import { determineMainOwnerInfo } from "app/NativeActions";

class MessageHeader extends Component {
  renderTitle(item) {
    if (item) {
      if (item.property) {
        const owner_info = determineMainOwnerInfo(item.property);
        return (
          <Wrapper>
            <Copy>
              <Bold>{owner_info.owner_name}</Bold>
            </Copy>
            <Copy>
              {item.lead_phone_number
                ? item.lead_phone_number.phone_number
                : ""}
            </Copy>
          </Wrapper>
        );
      }

      return (
        <Copy>
          <Bold>
            {item.lead_phone_number ? item.lead_phone_number.phone_number : ""}
          </Bold>
        </Copy>
      );
    }
  }

  renderMoreButton() {
    return (
      <Button
        style={{
          width: 40,
          height: 40,
          alignItems: "center",
          justifyContent: "center"
        }}
        onPress={() => {
          this.props.toggleActionSheet("conversation_more");
        }}
      >
        <Icon icon={"more-vert"} size={18} />
      </Button>
    );
  }

  renderCloseButton(conversations) {
    let is_open = false;

    for (let i = 0; i < conversations.length; i++) {
      if (conversations[i].closed_conversation == false) {
        is_open = true;
      }
    }

    if (
      this.props.update_conversation_loading.some(
        conversation_id => conversation_id === conversations[0].id
      )
    ) {
      return (
        <Wrapper
          style={{
            width: 40,
            height: 40,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Spin size="small" />
        </Wrapper>
      );
    } else if (is_open) {
      return (
        <Button
          style={{
            width: 40,
            height: 40,
            alignItems: "center",
            justifyContent: "center"
          }}
          tooltip={"Close Conversation"}
          tooltipPlacement={"bottom"}
          onPress={() => {
            this.props.updateConversation({
              token: this.props.token,
              type: "quick_close_conversation",
              conversation_id: conversations[0].id,
              onSuccess: () => {}
            });

            if (this.props.device == "mobile") {
              this.props.appRedirect({
                redirect: "goBack",
                payload: {
                  type: "message_engine"
                }
              });
            }
          }}
        >
          <Icon icon={"speaker-notes-off"} size={18} />
        </Button>
      );
    } else if (!is_open) {
      return (
        <Button
          style={{
            width: 40,
            height: 40,
            alignItems: "center",
            justifyContent: "center"
          }}
          tooltip={"Reopen Conversation"}
          tooltipPlacement={"bottom"}
          onPress={() => {
            this.props.updateConversation({
              token: this.props.token,
              type: "quick_open_conversation",
              conversation_id: conversations[0].id,
              onSuccess: () => {}
            });
          }}
        >
          <Icon icon={"sms"} size={18} />
        </Button>
      );
    }
  }

  renderLabel(conversation) {
    const { colors } = this.props;
    if (
      (conversation.lead_phone_number &&
        (conversation.lead_phone_number.bad_phone == 1 ||
          conversation.lead_phone_number.blocked == 1 ||
          conversation.lead_phone_number.do_not_call == 1 ||
          conversation.lead_phone_number.landline == 1)) ||
      conversation.awaiting_response_lock_out ||
      conversation.closed_conversation
    ) {
      let label_color = colors.error_color;
      let label_text = "";
      let label_text_color = colors.white_text_color;

      if (conversation.closed_conversation) {
        label_text = "Conversation Closed";
        label_text_color = colors.text_color;
        label_color = colors.gray_color;
      } else if (conversation.awaiting_response_lock_out) {
        label_text = "Conversation Locked";
        label_text_color = colors.text_color;
        label_color = colors.gray_color;
      } else if (conversation.lead_phone_number.blocked == 1) {
        label_color = colors.error_color;
        label_text = "Blocked";
      } else if (conversation.lead_phone_number.is_litigator == 1) {
        label_color = colors.error_color;
        label_text = "Known Litigator";
      } else if (conversation.lead_phone_number.do_not_call == 1) {
        label_color = colors.error_color;
        label_text = "Do Not Call";
      } else if (conversation.lead_phone_number.landline == 1) {
        label_color = colors.background_color;
        label_text = "Landline";
        label_text_color = colors.text_color;
      } else if (conversation.lead_phone_number.bad_phone == 1) {
        label_color = colors.error_color;
        label_text = "Wrong Number";
      } else if (conversation.lead_phone_number.expected_undeliverable) {
        label_color = this.props.colors.background_color;
        label_text = "Undeliverable";
        label_text_color = this.props.colors.text_color;
      }

      if (!!label_text) {
        return (
          <Row style={{ marginTop: 5 }}>
            <Wrapper
              style={{
                padding: 3,
                borderRadius: 20,
                paddingLeft: 10,
                paddingRight: 10,
                marginRight: 10,
                backgroundColor: label_color
              }}
            >
              <Copy
                style={{
                  color: label_text_color,
                  fontSize: 10
                }}
              >
                <Bold>{label_text}</Bold>
              </Copy>
            </Wrapper>
          </Row>
        );
      }
    }
  }

  renderLeadButton() {
    const {
      active_conversation,
      active_conversation_loading,
      colors,
      show_lead_info,
      toggle_conversation_lead_view
    } = this.props;
    if (
      active_conversation &&
      active_conversation.length > 0 &&
      !active_conversation_loading &&
      !toggle_conversation_lead_view
    ) {
      return (
        <Button
          style={{
            borderStyle: "solid",
            borderWidth: 1,
            padding: 10,
            borderRadius: 5,
            borderColor:
              active_conversation[0].property &&
              active_conversation[0].property.deal
                ? colors.border_color
                : colors.active_color,
            backgroundColor:
              active_conversation[0].property &&
              active_conversation[0].property.deal
                ? colors.background_color
                : colors.active_color
          }}
          onPress={() => {
            this.props.toggleConversationLeadView({
              show: true,
              new_property:
                active_conversation[0].property &&
                active_conversation[0].property.deal
                  ? false
                  : true
            });
            this.props.appRedirect({
              redirect: "goForward",
              payload: { add: "lead" }
            });
          }}
        >
          {active_conversation[0].property &&
          active_conversation[0].property.deal ? (
            <Copy>Show Lead</Copy>
          ) : (
            <Copy style={{ color: colors.white_color }}>Assign To Lead</Copy>
          )}
        </Button>
      );
    }
  }

  renderBackButtonOrImage() {
    const { active_conversation, colors } = this.props;
    if (this.props.isMobile) {
      return (
        <Button
          style={{
            width: 50,
            height: 40,
            alignItems: "center",
            justifyContent: "center"
          }}
          onPress={() => {
            this.props.appRedirect({
              redirect: "goBack",
              payload: { type: "message_engine" }
            });
            if (this.props.device == "desktop") {
              this.props.setActiveConversation({
                conversation: null
              });
            }
          }}
        >
          <Icon icon="arrow-back" size={28} />
        </Button>
      );
    }

    return <MessageHeaderImage item={active_conversation[0]} colors={colors} />;
  }

  render() {
    const { active_conversation, colors } = this.props;

    if (active_conversation && active_conversation.length > 0) {
      return (
        <Wrapper
          style={{
            marginTop: this.props.isMobile
              ? this.props.isIphoneX
                ? 42
                : this.props.platform == "ios"
                ? 25
                : 12
              : 0,
            backgroundColor: colors.background_color
          }}
        >
          <CardBody
            style={{
              borderBottomWidth: 1,
              borderBottomColor: colors.border_color,
              borderBottomStyle: "solid",

              padding: 15,
              paddingLeft: this.props.isMobile ? 0 : 15
            }}
          >
            <Row>
              {this.renderBackButtonOrImage()}
              <Wrapper style={{ flex: 1 }}>
                {this.renderTitle(active_conversation[0])}
                {this.renderLabel(active_conversation[0])}
              </Wrapper>
              <Row>
                {this.renderLeadButton()}
                {this.renderMoreButton()}
                {this.renderCloseButton(active_conversation)}
              </Row>
            </Row>
          </CardBody>
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default MessageHeader;
